import React, { useState, Component } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, AlertTriangleIcon, TrashIcon } from 'lucide-react';
export function DeleteAccount() {
  const [formState, setFormState] = useState({
    email: '',
    reason: '',
    confirmed: false
  });
  const [submitted, setSubmitted] = useState(false);
  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!formState.confirmed) return;
    const subject = encodeURIComponent(`Account Deletion Request — ${formState.email}`);
    const body = encodeURIComponent(`Account email: ${formState.email}\n\nReason (optional): ${formState.reason || 'Not provided'}\n\nI confirm that I want my Pawchi account and all associated data permanently deleted.`);
    window.location.href = `mailto:privacy@pawchi.app?subject=${subject}&body=${body}`;
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000);
  }
  return <div className="min-h-screen bg-cream" data-id="element-260">
      <div className="max-w-2xl mx-auto px-6 pt-32 pb-20" data-id="element-261">
        <Link to="/" className="inline-flex items-center gap-2 text-warmBrown/60 hover:text-peach transition-colors mb-8 font-medium" data-id="element-262">
          <ArrowLeftIcon size={18} data-id="element-263" />
          Back to Home
        </Link>

        <h1 className="text-4xl md:text-5xl font-black text-warmBrown mb-3" data-id="element-264">
          Delete your account
        </h1>
        <p className="text-warmBrown/60 text-lg mb-10" data-id="element-265">
          Request the permanent deletion of your Pawchi account and all
          associated data.
        </p>

        {/* Warning callout */}
        <div className="bg-peach/10 border border-peach/30 rounded-2xl p-5 mb-8 flex gap-3" data-id="element-266">
          <AlertTriangleIcon size={22} className="text-peach flex-shrink-0 mt-0.5" data-id="element-267" />
          <div className="text-warmBrown/80 text-sm leading-relaxed" data-id="element-268">
            <p className="font-bold mb-2" data-id="element-269">This action is permanent.</p>
            <p className="mb-3" data-id="element-270">
              When your account is deleted, the following data will be
              permanently removed within 30 days:
            </p>
            <ul className="list-disc pl-5 space-y-1" data-id="element-271">
              <li data-id="element-272">Your profile and account information</li>
              <li data-id="element-273">Your pet companions and their progress</li>
              <li data-id="element-274">All habit, mood, and breathing session history</li>
              <li data-id="element-275">Photos and any uploaded content</li>
              <li data-id="element-276">Settings and preferences</li>
            </ul>
            <p className="mt-3 text-warmBrown/60" data-id="element-277">
              Some anonymized data may be retained as required by law (e.g. for
              tax and audit purposes).
            </p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5" data-id="element-278">
          <div data-id="element-279">
            <label htmlFor="email" className="block text-sm font-medium text-warmBrown/70 mb-2" data-id="element-280">
              Account email
            </label>
            <input id="email" type="email" placeholder="The email associated with your Pawchi account" required value={formState.email} onChange={e => setFormState({
            ...formState,
            email: e.target.value
          })} className="w-full px-4 py-3 rounded-xl bg-white border border-warmBrown/10 text-warmBrown placeholder:text-warmBrown/30 focus:outline-none focus:border-peach/50 focus:ring-1 focus:ring-peach/30 transition-colors" data-id="element-281" />
          </div>

          <div data-id="element-282">
            <label htmlFor="reason" className="block text-sm font-medium text-warmBrown/70 mb-2" data-id="element-283">
              Reason for leaving (optional)
            </label>
            <textarea id="reason" placeholder="Help us improve — let us know why you're deleting your account" rows={4} value={formState.reason} onChange={e => setFormState({
            ...formState,
            reason: e.target.value
          })} className="w-full px-4 py-3 rounded-xl bg-white border border-warmBrown/10 text-warmBrown placeholder:text-warmBrown/30 focus:outline-none focus:border-peach/50 focus:ring-1 focus:ring-peach/30 transition-colors resize-none" data-id="element-284" />
          </div>

          <label className="flex items-start gap-3 cursor-pointer p-4 rounded-xl bg-white border border-warmBrown/10 hover:border-warmBrown/20 transition-colors" data-id="element-285">
            <input type="checkbox" required checked={formState.confirmed} onChange={e => setFormState({
            ...formState,
            confirmed: e.target.checked
          })} className="mt-1 w-4 h-4 accent-peach" data-id="element-286" />
            <span className="text-sm text-warmBrown/80 leading-relaxed" data-id="element-287">
              I understand that this action is permanent and cannot be undone. I
              want my Pawchi account and all associated data to be deleted.
            </span>
          </label>

          <button type="submit" disabled={!formState.confirmed} className="px-8 py-4 rounded-full font-bold text-white bg-peach hover:bg-peach/90 disabled:bg-warmBrown/20 disabled:cursor-not-allowed transition-colors shadow-soft-lg flex items-center gap-2" data-id="element-288">
            {submitted ? 'Opening email client...' : <>
                <TrashIcon size={16} data-id="element-289" />
                Request account deletion
              </>}
          </button>
        </form>

        <p className="mt-8 text-sm text-warmBrown/50 leading-relaxed" data-id="element-290">
          You can also request deletion directly from within the app under{' '}
          <span className="font-medium text-warmBrown/70" data-id="element-291">
            Settings → Account → Delete account
          </span>
          . Requests are typically processed within 7 business days.
        </p>
      </div>
    </div>;
}